"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordTabContent = exports.PasswordHint = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var Types = require("types");
var classNames = require("classnames");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var userSettings_1 = require("@caddigital/sok-reducers/lib/actions/user/userSettings");
var password_1 = require("utils/password");
var mapStateToProps = function (state) {
    return {
        isOpen: state.user.userSettings.isOpen,
        changePasswordStatus: state.user.userSettings.changePasswordStatus,
        oldPassword: state.user.userSettings.oldPassword,
        newPassword: state.user.userSettings.newPassword,
        confirmPassword: state.user.userSettings.confirmPassword
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    onChange: function (field, value) { return dispatch((0, userSettings_1.updatePasswordValue)(field, value)); },
    changePassword: function (oldPassword, newPassword) {
        return dispatch((0, userSettings_1.changePasswordRequest)(oldPassword, newPassword));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (nextProps.isOpen) {
            if (this.props !== nextProps) {
                return true;
            }
        }
        return false;
    }
}), recompose_1.pure);
var PasswordHint = function () { return (React.createElement("div", { className: 'password-hint' },
    React.createElement("p", null, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/passwordTab/goodPassword')),
    React.createElement("ul", null,
        React.createElement("li", null, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/passwordTab/hint1')),
        React.createElement("li", null, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/passwordTab/hint2')),
        React.createElement("li", null, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/passwordTab/hint3')),
        React.createElement("li", null, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/passwordTab/hint4')),
        React.createElement("li", null, (0, translation_1.getLocalization)('components/userSettingsGeneralModal/passwordTab/easyToRemember'))))); };
exports.PasswordHint = PasswordHint;
exports.PasswordTabContent = enhance(function (props) {
    var passwordStrength = (0, password_1.getStrength)(props.newPassword);
    return (React.createElement("div", { className: 'password-tab' },
        React.createElement(sok_ui_1.Grid.Row, null,
            React.createElement(sok_ui_1.Grid.Column, { medium: 6, className: 'password-form' },
                React.createElement("label", null,
                    React.createElement(Icon_1.Icon, { className: 'fa-unlock-alt' }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/passwordTab/label/oldPassword')),
                React.createElement(sok_ui_1.TextInput, { type: 'password', value: props.oldPassword, onChange: function (e) {
                        return props.onChange('oldPassword', e.target.value);
                    } }),
                React.createElement("label", null,
                    React.createElement(Icon_1.Icon, { className: 'fa-unlock-alt' }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/passwordTab/label/newPassword')),
                React.createElement(sok_ui_1.TextInput, { type: 'password', value: props.newPassword, onChange: function (e) {
                        return props.onChange('newPassword', e.target.value);
                    } }),
                React.createElement("label", null,
                    React.createElement(Icon_1.Icon, { className: 'fa-link' }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/passwordTab/label/passwordStrength')),
                React.createElement("div", { className: classNames('sok-text-input', 'strength-field', passwordStrength.className) },
                    React.createElement(Icon_1.Icon, { className: "fa-link", style: { color: 'black' } }),
                    React.createElement("div", { className: "strength-field-text" }, (0, translation_1.getLocalization)(passwordStrength.text))),
                React.createElement("label", null,
                    React.createElement(Icon_1.Icon, { className: 'fa-unlock-alt' }),
                    ' ',
                    (0, translation_1.getLocalization)('components/userSettingsGeneralModal/passwordTab/label/confirmPassword')),
                React.createElement(sok_ui_1.TextInput, { type: 'password', value: props.confirmPassword, onChange: function (e) {
                        return props.onChange('confirmPassword', e.target.value);
                    } }),
                React.createElement(sok_ui_1.Button, { color: "base-green", text: (0, translation_1.getLocalization)('components/userSettingsGeneralModal/buttons/changePassword'), disabled: props.newPassword !== props.confirmPassword ||
                        passwordStrength.level < 2 ||
                        props.changePasswordStatus.isBusy, icon: React.createElement(Icon_1.Icon, { className: "fa-check-circle" }), onClick: function () {
                        return props.changePassword(props.oldPassword, props.newPassword);
                    } })),
            React.createElement(sok_ui_1.Grid.Column, { medium: 6, className: 'password-hint' },
                React.createElement(exports.PasswordHint, null)))));
});
